import { Box, Typography } from '@mui/material';
import WavetrakLink from 'components/WavetrakLink';

import styles from './LiveWindSourceAttribution.module.scss';

export type LiveWindAttributionSources = 'BOM' | 'MADIS';

interface Props {
  source: LiveWindAttributionSources;
}

const BomAttribution: React.FC = () => (
  <Box>
    <WavetrakLink href="http://www.bom.gov.au/data-access/3rd-party-attribution.shtml">
      <Box className={styles.bomImage} />
    </WavetrakLink>
  </Box>
);

const MadisAttribution: React.FC = () => (
  <Box>
    <Typography component="p" variant="caption">
      Wind data provided by NOAA and its data providers. Liability of any kind arising from use of
      the data is disclaimed by the providers, including without limitation accuracy, reliability
      and fitness for a particular purpose.
    </Typography>
  </Box>
);

const LiveWindSourceAttribution: React.FC<Props> = ({ source }) => (
  <Box className={styles.attribution}>
    {source === 'BOM' && <BomAttribution />}
    {source === 'MADIS' && <MadisAttribution />}
  </Box>
);

export default LiveWindSourceAttribution;
